import { ANALYTICS_TEMPLATES } from './utilities/analytics/namespaces';
import { getOrCreateAnalytics } from './utils/analytics';

// @ts-expect-error - Legacy code
export function sendOnClickAnalytics({ analytic, namespace }): void {
	getOrCreateAnalytics().track(ANALYTICS_TEMPLATES.getClickEventName(namespace), analytic);
}
